module.exports = __webpack_public_path__ + "static/NEDesignSystemHero.a85e83ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/NEDesignSystemHero.jpg
// module id = 62
// module chunks = 65579394461380 159014900043430 246227742792961